module.exports = __webpack_public_path__ + "1826bae1dd211d5de3c6db407475601c.png";